import React from 'react';
import { Navbar, Nav, Container } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import KlassiBrand from './KlassiBrand';

const Header = () => {
  const location = useLocation();

  return (
    <Navbar bg="dark" variant="dark" expand="lg" className="py-3">
      <Container>
        <Navbar.Brand as={Link} to="/">
          <img
            src="/logo.png"
            alt="Klassi trademark logo"
            height="40"
            className="d-inline-block align-top me-2"
          />
          <KlassiBrand className="text-light" />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto">
            <Nav.Link 
              as={Link} 
              to="/" 
              className={location.pathname === '/' ? 'active text-warning' : 'text-light'}
              style={{ display: location.pathname === '/' ? 'none' : 'block' }}
            >
              Home
            </Nav.Link>
            <Nav.Link 
              as={Link} 
              to="/about" 
              className={location.pathname === '/about' ? 'active text-warning' : 'text-light'}
              style={{ display: location.pathname === '/about' ? 'none' : 'block' }}
            >
              About
            </Nav.Link>
            <Nav.Link
              as={Link}
              to="/contact"
              className={location.pathname === '/contact' ? 'active text-warning' : 'text-light'}
              style={{ display: location.pathname === '/contact' ? 'none' : 'block' }}
            >
              Contact
            </Nav.Link>
            <Nav.Link 
              as={Link} 
              to="/klassitech" 
              className={location.pathname.startsWith('/klassitech') ? 'active text-warning' : 'text-light'}
              style={{ display: location.pathname === '/klassitech' ? 'none' : 'block' }}
            >
              KlassiTech
            </Nav.Link>
            {/*<Nav.Link */}
            {/*  as={Link} */}
            {/*  to="/klassicare" */}
            {/*  className={location.pathname.startsWith('/klassicare') ? 'active text-warning' : 'text-light'}*/}
            {/*style={{ display: location.pathname === '/klassicare' ? 'none' : 'block' }}*/}
            {/*>*/}
            {/*  KlassiCare*/}
            {/*</Nav.Link>*/}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Header; 